import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../components/Header'
import Footer from '../components/Footer'

const Solutions = () => {
  return (
    <>
    <main>
      <Header />
    <div className="container">
      <h1 className="commonTitle">Решения</h1>
      <div className="commonBreadcrumbs">
        <ul>
            <li><Link to="/"><i className="fa-solid fa-house-chimney"></i></Link></li>
            /
            <li>Решения</li>
        </ul>
      </div>
      <div className='commonContent'>

      </div>
    </div>
    </main>
    <Footer />
  </>
  )
}

export default Solutions